import React, { useEffect, useState,useRef } from 'react';
import ReactGA from "react-ga4";
import emailjs from "@emailjs/browser";

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './Admin-Panel/contexts/AuthContext';
import { ThemeProvider } from './Admin-Panel/contexts/ThemeContext';
import ScrollToTop from './Component/ScrollToTop';

// Admin components
import AdminLayout from './Admin-Panel/Admin-components/AdminLayout';
import Dashboard from './Admin-Panel/Admin-components/Dashboard';
import UploadBlog from './Admin-Panel/Admin-components/UploadBlog';
import ManageBlogs from './Admin-Panel/Admin-components/ManageBlogs';
import AccountCenter from './Admin-Panel/Admin-components/AccountCenter';
import ProtectedRoute from './Admin-Panel/Admin-components/ProtectedRoute';
import AdminLogin from './Admin-Panel/Admin-components/AdminLogin';

// Website components
import Service from './Component/sub-component/Service';
import Housemaid from './Component/sub-component/Housemaid';
// import Cleaner from './Component/sub-component/Cleaner';
import Cook from './Component/sub-component/Cook';
import BabySitting from './Component/sub-component/BabySitting';
import Elderycare from './Component/sub-component/Elderycare'
import Driver from './Component/sub-component/Driver'
import Servant from './Component/sub-component/Servant'
import Patientcare from './Component/sub-component/Patientcare'
import Officeboy from './Component/sub-component/Officeboy';
import About from './Component/sub-component/About';
import Blog from './Component/sub-component/Blog';
import Needjob from './Component/Needjob' 
// import Register from './Component/register';
import BlogDetails from './Component/sub-component/BlogDetails';
import Contact from './Component/sub-component/Contact';
import JobMember from './Component/sub-component/JobMember';
import Footer from './Component/Footer';
import Header from './Component/Header';
import Home from './Component/Home';
import PrivacyPolicy from './Component/PrivacyPolicy'
import TermsandConditions from './Component/TermsandConditions'

import './Admin-Panel/styles/admin-global.css'; 
import { BlogProvider } from './Admin-Panel/contexts/BlogContext';
import { ToastContainer } from 'react-toastify';

//Page not found component
import NotFound from './Component/NotFound';
import Book from './Component/Book';

function App() {
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);
  const form = useRef();
  const [loading, setLoading] = useState(false);

  
  const toggleRegisterPopup = () => {
    setIsRegisterOpen(!isRegisterOpen);
  };

  const handleRegisterSubmit = (e) => {
    e.preventDefault();
    // Handle registration logic here
    alert('Registration submitted!');
    setIsRegisterOpen(false);
  };
  useEffect(()=>{
  ReactGA.initialize("AW-16629382441");

  ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "App.js" });

  },[]);

  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await emailjs.sendForm(
        "service_v4bj4cq", 
        "template_a7bino9", 
        form.current,
        "EPURM9NpZ87StWlSC" 
      );

      alert("✅ Message sent successfully!");
      e.target.reset();
    } catch (error) {
      console.error("FAILED...", error.text);
      alert("❌ Failed to send message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <ThemeProvider>
      <AuthProvider>
        <BlogProvider>
          <Router>
              <Routes>
                {/* Admin Routes */}
                
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                  <Route index element={<Navigate to="/admin/dashboard" replace />} />
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="upload-blog" element={<UploadBlog />} />
                  <Route path="manage-blogs" element={<ManageBlogs />} />
                  <Route path="account" element={<AccountCenter />} />
                </Route>

            {/* Main Website Routes */}
            <Route path="/*" element={
              <>
                <Header onRegisterClick={toggleRegisterPopup} />
               <ScrollToTop />
                <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/aboutus" element={<About/>} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:title" element={<BlogDetails />} />
                <Route path="/post-requirement" element={<Service />} />
                <Route path="/job-member" element={<JobMember />} />
                <Route path="/house-maid-services-in-ahmedabad" element={<Housemaid />} />
                {/* <Route path="/Bestmaid" element={<Cleaner />} /> */}
                <Route path="/cook-services-in-ahmedabad" element={<Cook />} />
                <Route path="/baby-sitting-services-in-ahmedabad" element={<BabySitting />} />
                <Route path='/elder-care-services-in-ahmedabad' element={<Elderycare/>}/>
                <Route path='/driver-services-in-ahmedabad' element={<Driver></Driver>}/>
                <Route path='/servant-services-in-ahmedabad-24-hours' element={<Servant></Servant>}/>
                <Route path='/patient-care-services-in-ahmedabad' element={<Patientcare></Patientcare>}/>
                <Route path='/office-boy-services-in-ahmedabad' element={<Officeboy/>}/>
                <Route path="/contact" element={<Contact />} />
                <Route path='/need-job' element={<Needjob/>}/>
                <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
                <Route path='/terms-conditions' element={<TermsandConditions></TermsandConditions>}/>
                <Route path='/Book-Now' element={<Book></Book>}/>
                <Route path="*" element={<NotFound />} />
                </Routes>
                <Footer />
                
                {/* Register Popup - Global */}
               {isRegisterOpen && (
            <div className="popup-overlay" onClick={toggleRegisterPopup}>
              <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                <button className="close-btn" onClick={toggleRegisterPopup}>×</button>

                <div className="form-header">
                  <h1>Book Now</h1>
                  {/* <div className="header-border"></div> */}
                </div>
               <form
                    className="contact-form"
                    ref={form}
                    onSubmit={sendEmail}
                  >
                    {/* <div className="form-group">
                      <label htmlFor="location">Maid in Ahmedabad</label>
                    </div> */}

                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Your Name*"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="emailid"
                        placeholder="Email Address*"
                        required
                      />
                    </div>
  
                    <div className="form-group">
                      <input
                        type="tel"
                        id="phone"
                        name="contactno"
                        placeholder="Phone Number*"
                        required
                      />
                    </div>
              

                    <div className="form-row">
                      <div className="form-group">
                        <select id="category" required name="ServiceRequired">
                          <option value="">Choose a category</option>
                          <option value="House Maid">House Maid</option>
                          <option value="Baby Sitting">Baby Sitting</option>
                          <option value="Elderly Care">Elderly Care</option>
                          <option value="Patient Care">Patient Care</option>
                          <option value="Cook">Cook</option>
                          <option value="Driver">Driver</option>
                          <option value="Full Time Servant">
                            24x7 Servant
                          </option>
                          <option value="Office Boy">Office Boy</option>
                          <option value="Pet Care">Pet Care</option>
                        </select>
                      </div>
                    </div>

                    {/* <div className="form-group">
                      <textarea
                        id="message"
                        placeholder="Your Message*"
                        rows="5"
                        name="user_message"
                        required
                      ></textarea>
                    </div> */}

                    <button
                  type="submit"
                  className="submit-btn1"
                  disabled={loading}
                  onClick={() => {
                    return window.gtag_report_conversion
                      ? window.gtag_report_conversion("https://jphomeservice.in/")
                      : true;
                  }}
                >
                  {loading ? "Sending..." : "Send Message"}
                </button>

                  </form>

                {/* <div className="form-footer">
                  <p className="login-link">
                    Already have an account? <a href="#login">Login here</a>
                  </p>
                </div> */}
              </div>
            </div>
          )}
              </>
            } />
          </Routes>
          </Router>
        </BlogProvider>
      </AuthProvider>
    </ThemeProvider>
    <ToastContainer position="top-right" autoClose={2000} />
    </>
  );
}

export default App;